<template>
    <div class="blog-page">
        <div class="container py-4 blog-container">
            <b-row>
                <b-col cols="12" lg="8" class="mb-3 mb-lg-0">
                    <div class="page-intro card-shell mb-3">
                        <h1 class="page-title">Blog InstaPrivat</h1>
                        <p class="page-subtitle">Tips belajar, strategi parenting, dan insight pendidikan terbaru dari InstaPrivat.</p>
                    </div>

                    <div v-if="isSearching" class="search-banner card-shell mb-3">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="search-label">
                                Hasil pencarian untuk <strong>"{{ searchQuery }}"</strong>
                            </div>
                            <b-button @click="reset" size="sm" variant="light" class="reset-btn" aria-label="Reset pencarian">
                                <font-awesome-icon icon="times-circle" aria-hidden="true" />
                            </b-button>
                        </div>
                    </div>

                    <div v-if="isProcessing" class="card-shell p-3">
                        <ContentLoader width="100%" height="420">
                            <rect x="0" y="10" rx="10" ry="10" width="100%" height="88" />
                            <rect x="0" y="114" rx="10" ry="10" width="100%" height="88" />
                            <rect x="0" y="218" rx="10" ry="10" width="100%" height="88" />
                            <rect x="0" y="322" rx="10" ry="10" width="100%" height="88" />
                        </ContentLoader>
                    </div>

                    <template v-else>
                        <div v-if="postList.length > 0" class="article-list">
                            <article v-for="post, index in postList" :key="index" class="card-shell article-card mb-3">
                                <div class="d-flex align-items-start justify-content-between gap-2">
                                    <div class="pr-2">
                                        <b-link @click="goto(post)" class="article-title text-ip" :title="post.title">
                                            {{ post.title }}
                                        </b-link>
                                        <div class="article-meta mt-2">
                                            <span v-if="post.date" class="meta-pill">
                                                <font-awesome-icon icon="calendar-alt" aria-hidden="true" /> {{ post.date }}
                                            </span>
                                            <span class="meta-pill">
                                                <font-awesome-icon icon="eye" aria-hidden="true" /> {{ post.views || 0 }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </article>

                            <div class="pagination-wrap mt-3">
                                <b-pagination-nav
                                    :link-gen="linkGen"
                                    :number-of-pages="totalPage"
                                    @change="fetchPostList"
                                    use-router
                                ></b-pagination-nav>
                            </div>
                        </div>

                        <div v-else class="card-shell p-4 empty-state">
                            <h4 class="mb-1">Belum ada artikel</h4>
                            <p class="mb-0">Coba kata kunci lain atau lihat kategori yang tersedia.</p>
                        </div>
                    </template>
                </b-col>

                <b-col cols="12" lg="4">
                    <div class="sidebar-block card-shell mb-3">
                        <h6 class="sidebar-title">Cari Artikel</h6>
                        <b-form @submit.prevent="searchPost">
                            <div class="input-group input-full-width">
                                <b-input
                                    v-model="searchQuery"
                                    type="text"
                                    placeholder="Contoh: tips belajar efektif"
                                    aria-label="Cari artikel"
                                ></b-input>
                                <div class="input-group-append">
                                    <b-button type="submit" variant="primary" class="search-btn" aria-label="Cari artikel">Cari</b-button>
                                </div>
                            </div>
                        </b-form>
                    </div>

                    <div class="sidebar-block card-shell mb-3">
                        <h6 class="sidebar-title">Kategori</h6>
                        <div class="category-wrap">
                            <b-link :to="{name: 'version2-blog-list'}" @click="reset" class="category-chip all-chip">
                                Semua
                            </b-link>
                            <b-link
                                v-for="category, index in category_list"
                                :key="index"
                                @click="gotoCategory(category.text)"
                                class="category-chip"
                            >
                                {{ category.text }}
                            </b-link>
                        </div>
                    </div>

                    <div v-if="latestPostList.length > 0" class="sidebar-block card-shell">
                        <h6 class="sidebar-title">Artikel Terbaru</h6>
                        <div class="latest-list">
                            <div v-for="post, index in latestPostList" :key="index" class="latest-item" :class="{'latest-item-border': latestPostList.length - 1 !== index}">
                                <b-link @click="goto(post)" class="latest-link text-ip">
                                    {{ post.title }}
                                </b-link>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { ContentLoader } from "vue-content-loader"
import { mapState } from 'vuex';

export default {
  components: {
        ContentLoader
  },
  computed: {
    ...mapState(["blog"]),
        category_list() {
            if (this.blog.categoryList)
                return this.blog.categoryList
            return []
    },
    totalPage() {
            if (!this.postCount) {
        return 1;
      }
            return Math.max(1, Math.ceil(this.postCount / this.perPage));
    },
  },

  created() {
        if (this.$route.query.search) {
      this.searchQuery = this.$route.query.search
      this.searchPost()
      this.fetchLatestPostList()
        } else this.fetchPostList()
    this.fetchCategoryList()
  },

  data() {
    return {
      postList: [],
      postCount: null,
      perPage: 20,
      searchQuery: null,
      isSearching: false,
      latestPostList: [],
      isProcessing: false,
    };
  },

  methods: {
    reset() {
            this.isSearching = false
            this.searchQuery = null
            this.fetchPostList()
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
        goto(post) {
            const parts = post.date.split("-");
            var day = parseInt(parts[parts.length - 1])
            var month = parseInt(parts[parts.length - 2])
            var year = parseInt(parts[parts.length - 3])
            this.$router.push({
                name: 'version2-blog-detail',
                params: { day: day, month: month, year: year, slug: post.slug }
            })
    },
        fetchLatestPostList() {
            axios.get(`/api/v1/blog/posts/?page_size=6&page=${this.$route.query.page || 1}`)
                .then(resp => {
                    if (resp.status == 200) {
                        this.latestPostList = resp.data.results
                    }
                })
    },
    fetchPostList() {
            this.latestPostList = []
            if (this.isSearching == false) {
                this.isProcessing = true
                axios.get(`/api/v1/blog/posts/?page_size=${this.perPage}&page=${this.$route.query.page || 1}`)
                    .then(resp => {
                        this.isProcessing = false
                        if (resp.status == 200) {
                            this.postList = resp.data.results
                            this.postCount = resp.data.count
                            for (let i = 0; i < resp.data.results.length; i++) {
                                if (i < 6) this.latestPostList.push(resp.data.results[i])
                            }
                        }
                    })
                    .catch(error => {
                        this.isProcessing = false
                    })
            } else this.searchPost()
    },
        gotoCategory(title) {
            this.$router.push({
                name: 'version2-blog-category',
                params: { category_name: title }
            })
    },
        searchPost() {
            if (this.searchQuery) {
                this.isProcessing = true
                axios.get(`/api/v1/blog/posts/?search=${this.searchQuery}&page_size=${this.perPage}&page=${this.$route.query.page || 1}`)
                    .then(resp => {
                        this.isProcessing = false
                        if (resp.status == 200) {
                            this.postList = resp.data.results
                            this.postCount = resp.data.count
                            this.isSearching = true
                        }
                    })
                    .catch(error => {
                        this.isProcessing = false
                    })
            }
    },
    fetchCategoryList() {
            this.$store.dispatch('blog/getAllCategories')
    }
  },
};
</script>

<style scoped>
.blog-page {
    background: linear-gradient(180deg, #f7fafc 0%, #f1f6fa 100%);
    min-height: 100vh;
}

.blog-container {
    font-size: 14px;
}

.text-ip {
    color: #0f6b87 !important;
}

.card-shell {
    background: #ffffff;
    border: 1px solid #e5edf3;
    border-radius: 12px;
    box-shadow: 0 4px 18px rgba(12, 56, 74, 0.06);
    padding: 1rem 1.1rem;
}

.page-title {
    font-size: 1.6rem;
    font-weight: 700;
    color: #103447;
    margin-bottom: 0.2rem;
}

.page-subtitle {
    color: #59707f;
    margin-bottom: 0;
}

.search-banner {
    border-left: 4px solid #0f6b87;
}

.search-label {
    color: #39515f;
}

.reset-btn {
    border: 1px solid #dbe7ef;
}

.article-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.article-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 26px rgba(12, 56, 74, 0.1);
}

.article-title {
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 1.4;
}

.article-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.meta-pill {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 12px;
    color: #4b6170;
    background: #eef5f9;
    border: 1px solid #d7e6ef;
    border-radius: 999px;
    padding: 0.2rem 0.55rem;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
}

.empty-state h4 {
    color: #183849;
}

.empty-state p {
    color: #607683;
}

.sidebar-title {
    color: #1d3a4a;
    font-weight: 700;
    margin-bottom: 0.8rem;
}

.search-btn {
    min-width: 70px;
    background: #0f6b87;
    border-color: #0f6b87;
}

.search-btn:hover,
.search-btn:focus {
    background: #0d5f78;
    border-color: #0d5f78;
}

.category-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.category-chip {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    padding: 0.3rem 0.6rem;
    border-radius: 999px;
    color: #0f6b87 !important;
    background: #eef6fb;
    border: 1px solid #d5e7f2;
    text-decoration: none;
}

.category-chip:hover {
    color: #fff !important;
    background: #0f6b87;
    border-color: #0f6b87;
}

.all-chip {
    background: #fff7dc;
    border-color: #f5de95;
    color: #8a6514 !important;
}

.latest-item {
    padding: 0.45rem 0;
}

.latest-item-border {
    border-bottom: 1px solid #ebf1f5;
}

.latest-link {
    font-size: 13px;
    line-height: 1.45;
}

@media (max-width: 991px) {
    .page-title {
        font-size: 1.35rem;
    }
}
</style>
